

















































import { computed, defineComponent, ref } from '@vue/composition-api';

const name = 'ttam-ad-text-textarea-lite';
export default defineComponent({
  name,
  components: {},
  props: {
    domId: {
      type: String,
      default: '',
    },
    // title文案
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 3,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    resize: {
      type: String,
      default: 'none',
    },
    inputClass: {
      type: String,
      default: '',
    },
    useCount: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 100,
    },
    throttleTime: {
      type: Number,
      default: 300,
    },
    // textarea默认只展示一行，超过多大宽度则换行
    newLineWidth: {
      type: Number,
      default: 350,
    },
    // 是否展示删除按钮
    showDeleteIcon: {
      type: Boolean,
      default: false,
    },
    autosize: {
      type: Object,
    },
    isValidateFailed: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const computedStringLength = computed(() => props.value.length);
    const overLimited = computed(() => props.value.length > props.maxLength);
    const titleInput = ref();
    const handleTextInput = val => {
      emit('input', val);
    };
    const handleFocus = () => {
      emit('focus');
    };
    const handleBlur = () => {
      // emit('blur');
    };
    const handleClick = () => {
      emit('click');
    };
    const handleKeydown = () => {
      emit('keydown');
    };
    const handleRecheck = () => {
      emit('recheck');
    };
    const handleDelete = () => {
      emit('delete');
    };
    /**
     * 粘贴文案时，存在转义字符，则自动过滤转义字符
     */
    return {
      overLimited,
      name,
      computedStringLength,
      titleInput,
      handleTextInput,
      handleFocus,
      handleBlur,
      handleClick,
      handleKeydown,
      handleRecheck,
      handleDelete,
    };
  },
});
